export default __webpack_public_path__ + "static/media/FCHOlogo1.211a2833.png";